export default __webpack_public_path__ + "assets/row.8d9780df.svg";